<template>
  <div ref="orderGroup" class="order-group-content" @click="onOrderGroupClick">
    <slot name="orderGroupTop"/>

    <template v-if="isReceipt">
      <div v-for="item in orderList" :key="item.id + ''" class="receipt-wrapper">
        <div class="image-wrapper">
          <van-image
            :width="pxTovw(74)"
            :height="pxTovw(74)"
            :src="receiptIcon"
          />
        </div>
        <div class="detail-wrapper">
          <div class="title">{{ item.productName }}</div>
          <div class="desc">{{ item.receiptItemReason }}</div>
        </div>
      </div>
    </template>
    <template v-else>
      <order-item
        v-for="(item, index) in orderList"
        :key="item.accountId +'index'+ index"
        :show="showDevelop ? index < expandNum ? true : false : true "
        :obj="item"
        :show-font-color-black="showFontColorBlack"
        :show-ship-btn="showShipBtn"
        @toFreeClass1="toFreeClass1">
        <template slot="orderContent" slot-scope="scope">
          <slot :scope="scope.scope" name="orderContent"/>
        </template>
      </order-item>
    </template>
    <slot name="orderGroupBottom"/>
  </div>
</template>

<script>
import { Image as VanImage } from 'vant';
import OrderItem from '../../components/order/orderItem.vue';

export default {
  components: {
    OrderItem,
    [VanImage.name]: VanImage
  },
  props: {
    // 订单列表数据
    orderList: {
      type: Array,
      default: () => [
      ]
    },
    isReceipt: {
      type: Boolean,
      default: false
    },
    showFontColorBlack: {
      type: Boolean,
      default: false
    },
    showDevelop: {
      type: Boolean,
      default: false
    },
    expandNum: {
      type: Number,
      default: 3
    },
    loading: {
      type: Boolean,
      default: false
    },
    showShipBtn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      receiptIcon: require('../../assets/img/order/ic-order-receipt.png')
    };
  },
  methods: {
    onOrderGroupClick() {
      this.$emit('order-group-click');
    },
    toFreeClass1(para) {
      this.$emit('toFreeClass', para);
    }
  }
};
</script>

<style scoped lang="scss">
.order-group-content {
  text-align: center;
  background: #fff;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 40px;

  .receipt-wrapper {
    display: flex;
    flex-direction: row;
    gap: 40px;
    padding-top: 26px;
    .image-wrapper {
      background: #E9F0FF;
      width: 100px;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 10px;
      flex-shrink: 0;
    }
    .detail-wrapper {
      text-align: left;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      overflow: hidden;
      .title {
        font-size: 28px;
        font-weight: 600;
        color: $text-primary;
        flex-shrink: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .desc {
        font-size: 24px;
        color: $text-secondary;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}

.single-line {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dash-line {
  width: 100%;
  height: 2px;
  background: #e0e0e0;
  opacity: 0.5;
}

.opacity-gray {
  opacity: 0.45;
  color: #000 !important;
}

.mt40 {
  margin-top: 40px;
}

.ml-auto {
  margin-left: auto;
  margin-right: 0;
}

.ml12 {
  margin-left: 12px;
}

.mt30 {
  margin-top: 30px;
}

.color-red {
  color: #ff4b13;
}
</style>



// WEBPACK FOOTER //
// src/components/order/orderGroup.vue